import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
import { FoldableListChatSkeleton } from '@/components/modules/Chat/FoldableListChat';
import { Skeleton } from '@/components/ui/FeedBack/Skeleton';
import { Card } from '@/components/ui/Surface/Card';
export const RfpMessageFormBoxSkeleton = (props) => {
    const { className = '' } = props;
    return (_jsxs(Card, Object.assign({ className: clsx('border border-solid border-dark', 'overflow-hidden', 'p-16', className), isRounded: true }, { children: [_jsx(Skeleton, { className: 'h-[20px] w-[160px]' }), _jsx(FoldableListChatSkeleton, { className: 'mt-8 ml-12' })] })));
};
